import { useContext } from 'react';
import { BoundaryElementContext } from './boundaryElementContext';
export function useBoundaryElement() {
    return useContext(BoundaryElementContext);
}
//# sourceMappingURL=useBoundaryElement.js.map